/**
 * Swipe slider
 * Javascript functionality for a front page.
 * @version 1.0.0
 * @exports slider
 */

export default class Slider {
	/**
	 * Constructor
	 * @public
	 */
	constructor() {
		this.slider = document.getElementsByClassName('news-flash__list')[0];
		if (this.slider) {
			this.slides = this.slider.getElementsByClassName(
				'news-flash__list__item'
			);
			this.slideWidth = this.slides[0].offsetWidth + 20;

			this.arrowLeft = document.getElementsByClassName('arrow-left')[0];
			this.arrowRight = document.getElementsByClassName('arrow-right')[0];

			this.handleTouch = this.handleTouch.bind(this);
			this.handleTouchMove = this.handleTouchMove.bind(this);
			this._left = this._left.bind(this);
			this._right = this._right.bind(this);

			if (
				navigator.userAgent.match(/Android/i) ||
				navigator.userAgent.match(/iPhone/i)
			) {
				this._initSlider();
			}
		}
	}

	_initSlider() {
		this.slides[0].remove();
		this.slider.addEventListener('touchstart', this.handleTouch);
		this.slider.addEventListener('touchmove', this.handleTouchMove);
		this.arrowLeft.addEventListener('mouseup', this._left);
		this.arrowRight.addEventListener('mouseup', this._right);

		/**
		 * Add first and last classes to slide items
		 * For get possible scroll to end and to start (without loop)
		 */
		this.slides[0].classList.add('first-slide');
		this.slides[this.slides.length - 1].classList.add('last-slide');

		this.arrowLeft.classList.add('disabled');
	}

	handleTouch(e) {
		this.touchDown = e.touches[0].clientX;
	}

	handleTouchMove(e) {
		if (!this.touchDown) {
			return;
		}

		const touchUp = e.touches[0].clientX;
		const touchDiff = this.touchDown - touchUp;

		if (touchDiff > 0) {
			this.handleSwipeRight(this.slider, this.slides);
		} else {
			this.handleSwipeLeft(this.slider, this.slides);
		}

		this.touchDown = null;
	}

	_left(e) {
		e.preventDefault();
		this.handleSwipeLeft(this.slider, this.slides);
	}

	_right(e) {
		e.preventDefault();
		this.handleSwipeRight(this.slider, this.slides);
	}

	handleSwipeLeft(slider, slides) {
		let currentSlide = slides[0];
		if (currentSlide.classList.contains('first-slide')) {
			this.arrowLeft.classList.add('disabled');
		} else {
			this.arrowRight.classList.remove('disabled');
			slides[0].remove();
			slider.appendChild(currentSlide);
		}
	}

	handleSwipeRight(slider, slides) {
		let currentSlide = slides[slides.length - 1];
		if (currentSlide.classList.contains('first-slide')) {
			this.arrowRight.classList.add('disabled');
		} else {
			this.arrowLeft.classList.remove('disabled');
			slides[slides.length - 1].remove();
			slider.prepend(currentSlide);
		}
	}
}
